module.exports = __webpack_public_path__ + "static/media/certificate.e3ebf361.png";